import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createChildItem: {
		id: 'issue-table-hierarchy.ui.create-child-button.create-child-item',
		defaultMessage: 'Create child item',
		description: 'Tooltip label for the button next to the issue type cell to create a child issue',
	},
	createWorkItem: {
		id: 'issue-table-hierarchy.ui.create-child-button.create-work-item',
		defaultMessage: 'Create work item',
		description:
			'Tooltip label for the button next to the group header to create a work item in that group',
	},
	createIssue: {
		id: 'issue-table-hierarchy.ui.create-child-button.create-issue',
		defaultMessage: 'Create issue',
		description:
			'Tooltip label for the button next to the group header to create an issue in that group',
	},
});
